<template>
  <div>
    <treeselect
    ref="treeselect"
      v-model="collections"
      valueConsistsOf="LEAF_PRIORITY"
      :multiple="true"
      :show-count="true"
      :options="options"
      :default-expand-level="1"
      :flatten-search-results="true"
      openDirection="below"
      placeholder="select database from below"
      :alwaysOpen="collections.length<1"

    />
       <!-- v-on:input="limiter" -->
  </div>
</template>

<script>
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import treeprocess from "@/components/utility/treeprocess";


export default {
  // register the component
  components: { Treeselect },

  data() {
    return {
    };
  },
  computed: {
      collections:{
          get:function(){return this.$store.state.aggcollections},
          set:function(val){this.$store.commit("setaggcollections",val)},
      },
    options() {
      //将collections中的value换成id
      let origin = this.$store.state.collections;
      let newtype = JSON.parse(JSON.stringify(origin));
      newtype.forEach(obj => {
        delete Object.assign(obj, { ["id"]: obj["value"] })["value"];
      });

      return treeprocess(newtype);
    }
  },
  methods: {

  }
};
</script>


// WEBPACK FOOTER //
// src/components/news/aggtree.vue